const deals = [
  {
    id: "D001",
    name: "Dallas Apartments",
    source: "broker_email",
    location: "5400 Lemmon Ave",
    city: "Dallas",
    state: "TX",
    zip: "75209",
    price: 2500000,
    units: 48,
    buildingType: "Multifamily",
    yearBuilt: 1998,
    squareFeet: 42000,
    capRate: 5.8,
    score: 82,
  },
  {
    id: "D002",
    name: "Houston Multifamily",
    source: "listings",
    location: "3200 Westheimer Rd",
    city: "Houston",
    state: "TX",
    zip: "77098",
    price: 3400000,
    units: 64,
    buildingType: "Multifamily",
    yearBuilt: 2003,
    squareFeet: 58000,
    capRate: 5.2,
    score: 76,
  },
  {
    id: "D003",
    name: "Austin Rentals",
    source: "listings",
    location: "1800 S Congress Ave",
    city: "Austin",
    state: "TX",
    zip: "78704",
    price: 2900000,
    units: 52,
    buildingType: "Multifamily",
    yearBuilt: 2007,
    squareFeet: 48000,
    capRate: 6.1,
    score: 88,
  },
  {
    id: "D004",
    name: "San Antonio Complex",
    source: "manual_upload",
    location: "410 E Commerce St",
    city: "San Antonio",
    state: "TX",
    zip: "78205",
    price: 1800000,
    units: 32,
    buildingType: "Multifamily",
    yearBuilt: 1995,
    squareFeet: 28000,
    capRate: 6.4,
    score: 71,
  },
  // Near-duplicate of D001 — same city, close price & units, different broker/source
  {
    id: "D005",
    name: "Lemmon Ave Residences",
    source: "listings",
    location: "5812 Lemmon Ave",
    city: "Dallas",
    state: "TX",
    zip: "75209",
    price: 2650000,
    units: 51,
    buildingType: "Multifamily",
    yearBuilt: 1999,
    squareFeet: 44500,
    capRate: 5.6,
    score: 79,
  },
  // Florida deal — broadens market for Investor Fit Score
  {
    id: "D006",
    name: "Orlando Garden Villas",
    source: "broker_email",
    location: "4200 S Orange Ave",
    city: "Orlando",
    state: "FL",
    zip: "32806",
    price: 3100000,
    units: 58,
    buildingType: "Multifamily",
    yearBuilt: 2005,
    squareFeet: 52000,
    capRate: 6.7,
    score: 85,
  },
];

export default deals;
